import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  SxProps,
  Theme,
  useTheme,
} from '@mui/material';
import { ReactNode } from 'react';

interface BaseBubbleProps {
  avatar?: ReactNode;
  title?: string | ReactNode;
  subheader?: string;
  children?: ReactNode;
  actions?: ReactNode;
  sx?: SxProps<Theme>;
}

const BaseBubble = ({
  avatar,
  title,
  subheader,
  children,
  actions,
  sx = {},
}: BaseBubbleProps): JSX.Element => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        width: 450,
        maxWidth: 'calc(100vw - 32px)',
        boxSizing: 'border-box',
        border: `1px solid ${theme.palette.divider}`,
        position: 'relative',
        zIndex: 1200,
        backgroundColor: theme.palette.background.paper,
        ...sx,
      }}
      onClick={(event) => event.stopPropagation()}
    >
      <CardHeader
        avatar={avatar}
        title={title}
        subheader={subheader}
        sx={{
          pt: !avatar && !title && !subheader ? 0 : 2,
          '& .MuiCardHeader-content': {
            '& .MuiCardHeader-title': {
              fontSize: 16,
              fontWeight: 600,
            },
            '& .MuiCardHeader-subheader': {
              fontSize: 14,
              fontWeight: 400,
            },
          },
        }}
      />
      <CardContent
        sx={{
          pt: 0,
          '&:last-child': {
            pb: 2,
          },
          '& > .MuiBox-root': {
            '&:not(:last-child)': {
              mb: 2,
            },
          },
        }}
      >
        {children}
      </CardContent>
      {actions && (
        <CardActions
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          {actions}
        </CardActions>
      )}
    </Card>
  );
};

export default BaseBubble;
